import React, { useEffect, useRef, useState } from "react";
import MenuSideBar from "./menusidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { apiUrl } from "../config/api";
import "./css/applayout.css";

function AppLayout() {
  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = useState(() =>
    new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );
  const [menuVisible, setMenuVisible] = useState(false);
  const [userMenuVisible, setUserMenuVisible] = useState(false);
  const menuRef = useRef(); // 👉 create a ref
  const userMenuRef = useRef();
  const realName = localStorage.getItem("realName") || "Usuario";
  const session = JSON.parse(localStorage.getItem("sessionData") || "{}");
  const userInitial = realName?.charAt(0)?.toUpperCase() || session?.username?.charAt(0)?.toUpperCase() || "U";

  // Update time
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(
        new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      );
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  // Detect outside clicks
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuVisible &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setMenuVisible(false);
      }

      if (
        userMenuVisible &&
        userMenuRef.current &&
        !userMenuRef.current.contains(event.target)
      ) {
        setUserMenuVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuVisible, userMenuVisible]);

  const handleLogout = async () => {
    if (session?.sessionKey && session?.username) {
      try {
        await fetch(apiUrl("/logout"), {
          method: "POST",
          credentials: "include",
          headers: {
            Authorization: session.sessionKey,
            Username: session.username,
          },
        });
      } catch (err) {
        console.error("Logout request failed:", err);
      }
    }

    localStorage.clear();
    navigate("/");
  };

  return (
    <div id="content-container">
      <header id="app-topbar">
        <button
          id="app-topbar-menu-button"
          type="button"
          onClick={() => setMenuVisible(!menuVisible)}
          aria-label="Abrir menú"
        >
          <span className="material-symbols-outlined">menu</span>
        </button>

        <div id="app-topbar-brand">
          <img src="/images/logowp.png" id="app-topbar-logo" alt="Kakao Apps" />
        </div>

        <div id="app-topbar-clock" aria-label="Hora actual">
          {currentTime}
        </div>

        <div id="app-topbar-user" ref={userMenuRef}>
          <button
            id="app-topbar-user-button"
            type="button"
            onClick={() => setUserMenuVisible((visible) => !visible)}
            aria-expanded={userMenuVisible}
            aria-haspopup="menu"
          >
            <span id="app-topbar-user-avatar">{userInitial}</span>
            <span id="app-topbar-user-name">{realName}</span>
            <span className="material-symbols-outlined" id="app-topbar-user-chevron">
              expand_more
            </span>
          </button>

          {userMenuVisible ? (
            <div id="app-topbar-user-menu" role="menu">
              <button
                type="button"
                role="menuitem"
                onClick={() => {
                  setUserMenuVisible(false);
                  navigate("/app/profile");
                }}
              >
                <span className="material-symbols-outlined">person</span>
                Perfil
              </button>
              <button
                type="button"
                role="menuitem"
                onClick={handleLogout}
              >
                <span className="material-symbols-outlined">logout</span>
                Cerrar sesión
              </button>
            </div>
          ) : null}
        </div>
      </header>

      <div id="app-body">
        <div
          id="left-content-container"
          className={menuVisible ? "mobile-visible" : ""}
          ref={menuRef}
        >
          <MenuSideBar visible={menuVisible} />
        </div>

        <div id="right-content-container">
        <div id="right-content-main-container">
          <Outlet />
        </div>
      </div>
      </div>
    </div>
  );
}

export default AppLayout;
